"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XS_FONT_SIZE = exports.SEGMENT_WIDTH_TO_FONT_SIZE_RATIO = exports.LARGE_FONT_SIZE = exports.DEFAULT_FONT_SIZE = void 0;
const DEFAULT_FONT_SIZE = exports.DEFAULT_FONT_SIZE = 16;
const LARGE_FONT_SIZE = exports.LARGE_FONT_SIZE = 64;
const XS_FONT_SIZE = exports.XS_FONT_SIZE = 28;
const SEGMENT_WIDTH_TO_FONT_SIZE_RATIO = exports.SEGMENT_WIDTH_TO_FONT_SIZE_RATIO = 0.8;